import { render, staticRenderFns } from "./MainteDeliverables.vue?vue&type=template&id=734e6487&scoped=true"
import script from "./MainteDeliverables.vue?vue&type=script&lang=js"
export * from "./MainteDeliverables.vue?vue&type=script&lang=js"
import style0 from "./MainteDeliverables.vue?vue&type=style&index=0&id=734e6487&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734e6487",
  null
  
)

export default component.exports